// import { consolidateStreamedStyles } from "styled-components";

const YEARS = 15;
const eachYear = (Array.apply(null, { length: YEARS }).map(Number.call, Number)).map(x => (x + 1));
const eachMonth = (Array.apply(null, { length: YEARS * 12 }).map(Number.call, Number)).map(x => (x + 1));
const lastMonthOfYear = (x, index) => (((index - 1) % 12) === 11);
const round2 = x => (parseFloat(x).toFixed(2));
const nonNegative = x => (x > 0 ? x : 0);

const seriesFutureHousePrice = ({ housePrice, futureHousePricePct}) => {
  const result = [ housePrice ];
  eachYear.forEach(year => {
    const prev = result[result.length - 1];
    const value = nonNegative(prev * (1 + futureHousePricePct * 0.01));
    result.push(value);
  });
  return result.map(round2);
};

const seriesNoRepayment = ({ loanTaken, interestTaken }) => {
  const monthlyResult = [ parseInt(loanTaken, 10) ];
  const interestRate = (interestTaken * 0.01) / 12;
  let interest = interestRate * parseFloat(monthlyResult[0]);

  eachMonth.forEach(month => {
    const prev = parseFloat(monthlyResult[monthlyResult.length - 1]);
    const value = nonNegative(prev + interest);
    interest = interestRate * value;
    monthlyResult.push(value);
  });
  return [ loanTaken ].concat(monthlyResult.map(round2).filter(lastMonthOfYear));
};

const series = ({ loanTaken, interestTaken, period, monthlyPayment, stopRepayment }, title) => {
  const monthlyResult = [ loanTaken ];
  const monthlyInterest = (interestTaken * 0.01) / 12;
  const monthToStop = stopRepayment * 12;

  const debug = [];
  eachMonth.forEach(month => {
    const prev = monthlyResult[monthlyResult.length - 1];
    const isMonthToPay = true; //  ((month % period) === 1)
    if (isMonthToPay) {
      const paid = (month > monthToStop) ? 0 : monthlyPayment;
      const value = nonNegative(prev + monthlyInterest * prev - paid);
      monthlyResult.push(value);
    } else {
      monthlyResult.push(prev);
    }
    if (month < 55) { debug.push({ isMonthToPay, prev, value: monthlyResult[monthlyResult.length - 1] })}
  });

  // if (title) {console.table(debug);}
  return [ loanTaken ].concat(monthlyResult.map(round2).filter(lastMonthOfYear));
};

const stopAfterZero = arr => {
  const zeroIndex = arr.findIndex(x => (x <= 0));
  return (zeroIndex !== -1) ? arr.slice(0, zeroIndex + 1) : arr;
};

export const partialRepaymentOutput = (input) => {
  const { loanTaken, interestTaken, capitalValue } = input;
  const monthlyInterestRepayment = parseFloat((loanTaken * (interestTaken * 0.01) / 12).toFixed(2));
  const futureHousePrice = seriesFutureHousePrice(input);
  const cappedWithHp = (arr) => arr.map((x, index) => ((parseFloat(x, 10) > parseFloat(futureHousePrice[index], 10)) ? futureHousePrice[index] : x));
  const noRepayments = cappedWithHp(seriesNoRepayment(input));

  const payingOffInterest = cappedWithHp(series({ ...input, stopRepayment: input.stopPayingOffInterest, monthlyPayment: monthlyInterestRepayment }, "payingOffInterest" ));
  const partialRepayment = cappedWithHp(stopAfterZero(series({ ...input, stopRepayment: input.stopPartialRepayment, monthlyPayment: capitalValue })));
  const maxStopAfter = partialRepayment.findIndex(x => (x <= 0));
  return {
    monthlyInterestRepayment,
    maxStopAfter,
    series: {
      futureHousePrice,
      noRepayments,
      payingOffInterest,
      partialRepayment
    }
  };
};



// WEBPACK FOOTER //
// ./src/services/PartialRepaymentCalc.js